export default function deleteMigrationReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'DELETE_MIGRATION_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'DELETE_MIGRATION_ERROR':
            return {...state, ...{error: action.error}};

        case 'DELETE_MIGRATION_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}